import PhotoSwipeLightbox from 'photoswipe/lightbox';
import ObjectPosition from '@vovayatsyuk/photoswipe-object-position';
import 'photoswipe/style.css';

export class Lightbox {
    constructor(private gallery: HTMLElement) {
        this.init();
    }

    init() {
        const lightbox = new PhotoSwipeLightbox({
            gallery: this.gallery,
            children: 'a',
            pswpModule: () => import('photoswipe'),
            wheelToZoom: true,
            bgClickAction: 'close',
            tapAction: 'close',
            closeOnVerticalDrag: true,
            paddingFn: (viewportSize) => {
                return {
                    top: viewportSize.y * 0.1,
                    right: viewportSize.x * 0.1,
                    bottom: viewportSize.y * 0.1,
                    left: viewportSize.x * 0.1
                };
            },
        });

        interface ItemData {
            element: HTMLElement;
            src?: string;
            type?: string;
            iframe?: string;
        }

        // Add filter to process iframe items
        lightbox.addFilter('itemData', (itemData: ItemData, index: number): ItemData => {
            const iframe = itemData.element.dataset.iframe;

            if (iframe) {
                itemData.iframe = iframe;
                itemData.type = 'iframe';
            }

            return itemData;
        });

        // Handle content load for iframe items
        lightbox.on('contentLoad', (e) => {
            const {content} = e;
            if (content.type === 'iframe') {
                // prevent the default behavior
                e.preventDefault();

                // Create a container for the iframe
                content.element = document.createElement('div');
                content.element.className = 'pswp__iframe-container';
                content.element.innerHTML = content.data.iframe;
            }
        });

        new ObjectPosition(lightbox);

        lightbox.init();
    }
}

window.addEventListener("load", () => {
    const galleries = document.querySelectorAll<HTMLElement>(".pswp-gallery");

    galleries?.forEach((gallery) => {
        if (gallery.querySelector('.product_gallery-splide')) {
            return; // Already initialized in splide.ts
        }

        new Lightbox(gallery);
    })
});